import './WelcomePage.css'
import { logout as apiLogout, me } from '../../utils/authHelper'
import { clearSessionUser, readSessionUser } from '../../utils/sessionHelper'
import { useEffect, useState } from 'react'
import type { AuthUser } from '../../utils/authHelper'

const WelcomePage: React.FC = () => {
    const [user, setUser] = useState<AuthUser | null>(readSessionUser())

    useEffect(() => {
        const run = async () => {
            const ok = await me()
            if (!ok) {
                clearSessionUser()
                window.location.href = '/login'
                return
            }
        }

        run()
    }, [])

    const doLogout = async () => {
        await apiLogout()
        clearSessionUser()
        window.location.href = '/login'
    }

    const goToTool = () => {
        window.location.href = '/'
    }

    return (
        <main className='authPage'>
            <div className='authCard'>
                <img
                    className='authLogo'
                    src='https://www.familienkost.de/icon-svgs/logos/Familienkost_Logo_Horizontal_Farbig.svg'
                    alt='Familienkost Logo'
                />

                <div className='authEmblem' aria-hidden='true'>
                    <span>✅</span>
                </div>

                <h1 className='authTitle'>Willkommen</h1>

                {user ? (
                    <div className='authProfile'>
                        <img className='authAvatar' src={user.image_url} alt={`${user.firstname} ${user.lastname}`} />
                        <div className='authProfileText'>
                            <div className='authName'>{user.firstname} {user.lastname}</div>
                            <div className='authRole'>{user.role}</div>
                        </div>
                    </div>
                ) : (
                    <p className='authSubtitle'>Du bist eingeloggt.</p>
                )}

                <button className='authButton authButtonPrimary' type='button' onClick={goToTool}>
                    Zum Invoice-Tool
                </button>

                <button className='authButton authButtonGhost' type='button' onClick={doLogout}>
                    Abmelden
                </button>

                <p className='authFooter'>
                    © Familienkost ·{' '}
                    {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
                </p>
            </div>
        </main>
    )
}

export default WelcomePage